// `/app/developers/webhooks/deliveries` virou `/app/developers?tab=webhooks` (WEB-121): a
// tela morou aqui até a WEB-57/108, agora é a seção "Entregas recentes" da aba Webhooks.
// Rota mantida só como redirect, preservando `status`, `target`, `q` e o `id` da entrega
// (renomeado para `delivery`: a aba única já usa `id` para o endpoint, ver "Questões
// abertas" da rota nova).

import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { DELIVERY_STATUSES, DELIVERY_TARGETS } from '../features/webhooks/model.ts';

const searchSchema = z.object({
  status: z.enum(DELIVERY_STATUSES).optional().catch(undefined),
  target: z.enum(DELIVERY_TARGETS).optional().catch(undefined),
  q: z.string().optional().catch(undefined),
  id: z.string().min(1).optional().catch(undefined),
});

export const Route = createFileRoute('/app/developers/webhooks/deliveries/')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/app/developers',
      search: {
        tab: 'webhooks',
        status: search.status,
        target: search.target,
        q: search.q,
        delivery: search.id,
      },
    });
  },
});
